'use client';
import Button from '@/components/button/button';
import { useUserProfile } from '@/contexts/UserProfileContext';
import React from 'react';

export default function BannerButton({
  buttonText,
  buttonLink,
}: {
  buttonText: string;
  buttonLink: string;
}) {
  const { userProfile } = useUserProfile();
  return (
    <>
      {userProfile ? (
        <Button variant="primary" size="lg" href="/pricing">
          Find a Plan
          {/* {homePageData?.hero?.mainCtabutton?.buttonText} */}
        </Button>
      ) : (
        <Button variant="primary" size="lg" href={buttonLink}>
          {buttonText}
        </Button>
      )}
    </>
  );
}
